import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Line, Bar, Pie, Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import 'bootstrap/dist/css/bootstrap.min.css';


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const Dashboard = () => {
    
    const lineData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'Sales ($)',
                data: [4000, 3000, 5000, 6000, 7000, 8000, 9000],
                borderColor: 'rgba(75,192,192,1)',
                backgroundColor: 'rgba(75,192,192,0.2)',
                fill: true,
                tension: 0.4,
            },
        ],
    };

    const barData = {
        labels: ['Product A', 'Product B', 'Product C', 'Product D'],
        datasets: [
            {
                label: 'Units Sold',
                data: [200, 150, 300, 100],
                backgroundColor: ['rgba(255,99,132,0.2)', 'rgba(54,162,235,0.2)', 'rgba(255,206,86,0.2)', 'rgba(75,192,192,0.2)'],
                borderColor: ['rgba(255,99,132,1)', 'rgba(54,162,235,1)', 'rgba(255,206,86,1)', 'rgba(75,192,192,1)'],
                borderWidth: 1,
            },
        ],
    };

    const pieData = {
        labels: ['Chrome', 'Firefox', 'Edge', 'Safari'],
        datasets: [
            {
                data: [65, 20, 10, 5],
                backgroundColor: ['rgba(255,99,132,0.6)', 'rgba(54,162,235,0.6)', 'rgba(255,206,86,0.6)', 'rgba(75,192,192,0.6)'],
                hoverBackgroundColor: ['rgba(255,99,132,0.8)', 'rgba(54,162,235,0.8)', 'rgba(255,206,86,0.8)', 'rgba(75,192,192,0.8)'],
            },
        ],
    };

    const doughnutData = {
        labels: ['Mobile', 'Tablet', 'Desktop'],
        datasets: [
            {
                data: [300, 50, 100],
                backgroundColor: ['rgba(75,192,192,0.6)', 'rgba(255,159,64,0.6)', 'rgba(153,102,255,0.6)'],
                hoverBackgroundColor: ['rgba(75,192,192,0.8)', 'rgba(255,159,64,0.8)', 'rgba(153,102,255,0.8)'],
            },
        ],
    };

    return (
        <>
            <div className="container-fluid  px-3 g-0">
                <div className="row">
                    <div className="col-sm-1  g-0">
                    </div>
                    <div className="col-lg-12 px-4  g-2">
                        <div className="mt-4 g-0">
                            <div className="mb-4">
                                <Col md={10}>
                                    <h2>Dashboard</h2>
                                </Col>
                            </div>
                            <Row>
                                {/* Line Chart */}
                                <Col md={6} className="mb-4">
                                    <Card className="shadow-sm">
                                        <Card.Body>
                                            <Card.Title>Sales Over Time</Card.Title>
                                            <Line data={lineData} />
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Bar Chart */}
                                <Col md={6} className="mb-4">
                                    <Card className="shadow-sm">
                                        <Card.Body>
                                            <Card.Title>Product Sales</Card.Title>
                                            <Bar data={barData} />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                {/* Pie Chart */}
                                <Col md={6} className="mb-4">
                                    <Card className="shadow-sm">
                                        <Card.Body>
                                            <Card.Title>Browser Usage</Card.Title>
                                            <Pie data={pieData} />
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Doughnut Chart */}
                                <Col md={6} className="mb-4">
                                    <Card className="shadow-sm">
                                        <Card.Body>
                                            <Card.Title>Device Usage</Card.Title>
                                            <Doughnut data={doughnutData} />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;
